import React from 'react';
import {Card, Col, Image, Row} from "react-bootstrap";
import {
    FaBookOpen,
    FaCoins,
    FaDollarSign,
    FaGlobe,
    FaSass,
    FaTasks
} from "react-icons/fa";


const AssignUserItem = ({ assignment, onClick }) => {

    const date = new Date((assignment?.start_rev_date + assignment?.turnaround_time) * 60 * 1000);

// Массив с сокращениями месяцев
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Получаем месяц, день, год, часы и минуты
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const isMobile = window.innerWidth < 480; // или useMediaQuery

// Форматируем вывод (часы и минуты с ведущим нулем, если нужно)
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = hours < 10 ? `0${hours}` : hours;

    const daysToRead = Math.ceil(assignment.turnaround_time / 60 / 24 );

    const statusConfig = {
        READING: { color: "bg-success bg-opacity-50 text-dark", text: "READING" },
        READING_RIDT: { color: "bg-warning text-dark", text: "READING" },
        READING_RE: { color: "bg-danger text-white", text: "READING" },
        REPORTED: { color: "bg-success bg-opacity-50 text-dark", text: "AWAITING" },
        REPORTED_RFU: { color: "bg-warning text-dark", text: "AWAITING" },
        REPORTED_RV: { color: "bg-danger text-white", text: "AWAITING" },
        SUCCESS: { color: "bg-success text-white", text: "CONFIRMED" },
    };

    const status = statusConfig[assignment.assignment_status];

    return (
        <>
            {!isMobile && (
                <Col md={4} className="d-flex justify-content-center p-0">
                    {/* ✅ Оригинальная десктопная карточка — не меняем */}
                    <Card
                        className="mt-2 mb-0"
                        style={{
                            borderRadius: '6px',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                            height: '165px',
                            width: '340px',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            cursor: 'pointer',
                            border: '1px solid gray',
                        }}
                        onClick={onClick}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = '0px 6px 16px rgba(0, 0, 0, 0.2)';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = '0px 2px 4px rgba(0, 0, 0, 0.1)';
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        <Card.Body>
                            <Row>
                                {!isMobile && (
                                    <Col md={4} className="d-flex justify-content-center align-items-center position-relative"
                                         style={{
                                             borderRadius: "6px",  // ✅ Скругление углов контейнера
                                             overflow: "hidden",   // ✅ Скрываем лишнее, чтобы углы были ровными
                                             backgroundColor: "white", // ✅ Фон контейнера, заполняет белые зоны

                                         }}
                                    >
                                        <Image
                                            width="auto"
                                            height="auto"
                                            src={assignment.book.cover_file
                                                ? `${process.env.REACT_APP_API_URL}covers/${assignment.book.cover_file}`
                                                : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`}
                                            style={{
                                                objectFit: 'contain', // ✅ Масштабируем без обрезки
                                                borderRadius: '6px',  // ✅ Скругляем углы у самой картинки
                                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.0)',
                                                maxHeight: "120px",
                                                maxWidth: "90px",
                                                backgroundColor: "white", // ✅ Фон изображения (при необходимости)
                                            }}
                                        />
                                    </Col>
                                )}

                                <Col
                                    md={8}
                                    className={`flex-column justify-content-lg-start small p-0 ${isMobile ? 'ms-3' : ''}`}
                                >
                                    <p
                                        className="fw-bold mb-0 text-muted"
                                        style={{
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            WebkitLineClamp: 1, // Ограничение до 2 строк
                                        }}
                                    >
                                        {assignment.book.title}
                                    </p>

                                    <p
                                        className="fst-italic mb-1 text-muted small"
                                        style={{
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            WebkitLineClamp: 1, // Ограничение до 2 строк
                                        }}
                                    >
                                        {assignment.book.subtitle}
                                    </p>

                                    <Row className="gap-0">
                                        <p className="me-2 mb-0 mt-0 small text-muted" style={{ lineHeight: "1" }}>
                                            <FaBookOpen className="me-2" />
                                            Due: <strong>{`${month}-${day}`}</strong>,&nbsp;
                                            Read in: <strong>{daysToRead}</strong> Day{daysToRead >= 1 ? "s" : ""},
                                        </p>

                                        <p className="me-2 mb-0 mt-0 small text-muted" style={{ lineHeight: "1" }}>
                                            <FaCoins className="me-2" />
                                            Earnings: <strong>{assignment.assignment_price_reader}</strong> Virt
                                            {assignment?.received_bonus > 0 && (
                                                <>,&nbsp;<strong>+{assignment.received_bonus}</strong> V Bonus</>
                                            )}
                                        </p>



                                        <p className="me-2 mb-0 mt-0 small text-muted" style={{ lineHeight: "1.2" }}>
                                            <FaTasks className="me-2" />
                                            {Number(assignment?.assTypeId) === 32 ? "Leave star rating" : assignment.assignment_type},
                                        </p>
                                        <p className="me-2 mb-0 mt-0 small text-muted" style={{ lineHeight: "1.2" }}>
                                            <FaDollarSign className="me-2 mb-0 mt-0 small text-muted"/>
                                            Spends:
                                            <b className="text-danger">
                                                {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(assignment?.assTypeId) ? (
                                                    assignment?.assignment_price_publisher
                                                        ? ` $${assignment?.book_cost_compensation} (Rebatable)`
                                                        : "N/A"
                                                ) : (
                                                    (() => {
                                                        let priceLabel;
                                                        switch (assignment?.booksPriceId) {
                                                            case 1:
                                                                priceLabel = " Free";
                                                                break;
                                                            case 2:
                                                                priceLabel = " $0.99";
                                                                break;
                                                            case 3:
                                                                priceLabel = " $1.99";
                                                                break;
                                                            case 4:
                                                                priceLabel = " $2.99";
                                                                break;
                                                            case 5:
                                                                priceLabel = " $3.99";
                                                                break;
                                                            case 6:
                                                                priceLabel = " $4.99";
                                                                break;
                                                            case 7:
                                                                priceLabel = " $5.99";
                                                                break;
                                                            case 8:
                                                                priceLabel = " $6.99";
                                                                break;
                                                            case 9:
                                                                priceLabel = " $7.99";
                                                                break;
                                                            case 10:
                                                                priceLabel = " $8.99";
                                                                break;
                                                            case 11:
                                                                priceLabel = " $9.99";
                                                                break;
                                                            default:
                                                                priceLabel = " Unknown Type";
                                                        }

                                                        // Добавляем " Promo" при нужных условиях
                                                        if (assignment?.booksPriceId === 1 && [3, 4, 5, 6, 32].includes(assignment?.assTypeId)) {
                                                            priceLabel += " Promo";
                                                        }

                                                        return priceLabel;
                                                    })()
                                                )}




                                            </b>
                                        </p>
                                        <p className="me-2 mb-0 mt-0 small text-muted" style={{ lineHeight: "1.2" }}>
                                            <FaGlobe className="me-2" />
                                            Language: <strong>{assignment?.book?.language}</strong>,&nbsp;
                                            <strong>{assignment?.book?.total_words}</strong> W,
                                        </p>
                                        <p className="me-2 mb-0 mt-0 small text-muted" style={{ lineHeight: "1.2" }}>
                                            <FaSass className="me-2" />
                                            Current Step: <strong >{assignment?.reviewer_reading_step}</strong>
                                        </p>

                                    </Row>
                                    {/* Бейдж, который будет располагаться снизу и пересекать картинку */}

                                    <span
                                        className="text-danger fw-semibold position-absolute"
                                        style={{
                                            bottom: '2%',
                                            left: '18%',
                                            transform: 'translateX(-50%)',
                                            fontSize: '0.8rem',
                                            textShadow: '0px 1px 2px rgba(0,0,0,0.1)',
                                        }}
                                    >
  +{assignment.assignment_price_reader} Virt
</span>


                                    {assignment.assTypeId === 5 || assignment.assTypeId === 6 ? (
                                        <>
                            <span className="badge bg-warning bg-opacity-75 text-dark position-absolute"
                                  style={{
                                      bottom: '93%', left: '17%',
                                      transform: 'translateX(-50%)',
                                      gap: '3px', // Добавляет отступ между текстом и иконкой
                                      width: '88px',  // Фиксированная ширина
                                      height: '18px', // Фиксированная высота
                                      display: 'flex', // Делаем flex-контейнером
                                      justifyContent: 'center', // Центрируем содержимое по горизонтали
                                      alignItems: 'center', // Центрируем по вертикали
                                      padding: '2px 18px', fontSize: '0.8rem', fontStyle: 'italic',
                                      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
                                  }}>
                      Search&Buy


                             </span>
                                        </>
                                    ) : ('')}

                                    {assignment.assTypeId === 4 || assignment.assTypeId === 6 || assignment.assTypeId === 9 ? (
                                        <>
                            <span className="badge bg-info bg-opacity-50 text-dark position-absolute"
                                  style={{
                                      bottom: '93%', left: '52%',
                                      transform: 'translateX(-50%)',
                                      gap: '3px', // Добавляет отступ между текстом и иконкой
                                      width: '60px',  // Фиксированная ширина
                                      height: '18px', // Фиксированная высота
                                      display: 'flex', // Делаем flex-контейнером
                                      justifyContent: 'center', // Центрируем содержимое по горизонтали
                                      alignItems: 'center', // Центрируем по вертикали
                                      padding: '2px 18px', fontSize: '0.8rem', fontStyle: 'italic',
                                      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
                                  }}>
                       Photo


                             </span>
                                        </>
                                    ) : ('')}



                                    {status && (
                                        <span
                                            className={`badge text-uppercase position-absolute ${status.color}`}
                                            style={{
                                                bottom: '4%', left: '86%',
                                                transform: 'translateX(-50%)',
                                                width: '80px', height: '16px',
                                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                                padding: '2px 18px', fontSize: '0.7rem',
                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
                                            }}
                                        >
                                      {status.text}
        </span>
                                    )}



                                </Col>

                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            )}

            {isMobile && (
                <Col xs={12} className="d-flex justify-content-center">
                    <Card
                        className="mt-2 mb-2 p-2"
                        style={{
                            width: '100%',
                            maxWidth: '380px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            border: '1px solid gray',
                        }}
                        onClick={onClick}
                    >
                        <Row className="g-2 p-1 align-items-center">
                            {/* Обложка */}
                            <Col xs={4} className="d-flex justify-content-center align-items-center">
                                <Image
                                    src={assignment.book.cover_file
                                        ? `${process.env.REACT_APP_API_URL}covers/${assignment.book.cover_file}`
                                        : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`}
                                    style={{
                                        objectFit: 'contain',
                                        borderRadius: '4px',
                                        maxHeight: "140px",
                                        maxWidth: "100px",
                                        backgroundColor: "white",
                                    }}
                                />
                            </Col>

                            {/* Информация */}
                            <Col xs={8} className="text-muted small"  >
                                <p className="fw-bold mb-1 text-truncate"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}
                                >{assignment.book.title}</p>
                                <p className="fst-italic mb-1 text-muted small"
                                   style={{
                                       lineHeight: '1.2em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 2, // Ограничение до 2 строк
                                   }}
                                >{assignment.book.subtitle}</p>

                                <p className="mb-1"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}><FaBookOpen className="me-1" />Due: <b>{`${month}-${day}`}</b>, {daysToRead}d</p>
                                <p className="mb-1"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}><FaCoins className="me-1" />+{assignment.assignment_price_reader} Virt {assignment?.received_bonus !== 0 && `(+${assignment.received_bonus} Bonus)`}</p>
                                <p className="mb-1"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}><FaDollarSign className="me-1" />Spends: {assignment.assignment_price_amz}</p>

                                <p className="mb-1"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}><FaGlobe className="me-1" />{assignment?.book?.language}, {assignment?.book?.total_words} words</p>
                                <p className="mb-0"
                                   style={{
                                       lineHeight: '0.8em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}><FaSass className="me-1" />Step: {assignment?.reviewer_reading_step}.  Status:

                                {/* ✅ Мини бейдж со статусом */}
                                {status && (
                                    <span
                                        className={`badge mt-0 ms-2 text-uppercase ${status.color}`}
                                        style={{
                                            fontSize: '0.65rem',
                                            padding: '3px 8px',
                                        }}
                                    >
                  {status.text}
                </span>
                                )}</p>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            )}
        </>
    );



};

export default AssignUserItem;
